// src/components/AdheseInit.js
import { useEffect } from "react";

const AdheseInit = () => {
  useEffect(() => {
    const fetchAndRenderAd = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const creativeId = urlParams.get("adhesePreviewCreativeId");
      const slotId = urlParams.get("adhesePreviewSlotId");
      const slotTarget = urlParams.get("adhesePreviewCreativeTemplate");

      if (!creativeId || !slotId || !slotTarget) {
        console.error("Missing required ad parameters");
        return;
      }

      try {
        const response = await fetch(
          `https://uncommonmedia-preview.adhese.org/creatives/preview/tag.do?id=${creativeId}&slotId=${slotId}`,
        );

        if (!response.ok)
          throw new Error(`Ad fetch failed: ${response.status}`);

        const adHtml = await response.text();
        const adSlot = document.getElementById(slotTarget);

        if (!adSlot) {
          console.error(`Ad slot #${slotTarget} not found`);
          return;
        }

        // Extract content from document.write if present
        const documentWriteMatch = adHtml.match(
          /document\.write\(['"](.*?)['"]\)/,
        );
        const content = documentWriteMatch?.[1]
          ? documentWriteMatch[1]
              .replace(/\\"/g, '"')
              .replace(/\\'/g, "'")
              .replace(/\\n/g, "")
          : adHtml;

        // Update the ad slot
        adSlot.innerHTML = content;
        adSlot.classList.remove(
          "bg-white",
          "border",
          "flex",
          "items-center",
          "justify-center",
          "text-sm",
          "text-gray-500",
        );
      } catch (error) {
        console.error("Ad load error:", error);
        const adSlot = document.getElementById(slotTarget);
        if (adSlot) adSlot.innerHTML = "Ad failed to load";
      }
    };

    fetchAndRenderAd();
  }, []);

  return null;
};

export default AdheseInit;
